import { action, computed, when } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { client, Input, AppManager } from 'core';
import { analytics } from 'core/analytics';

import { clientStore } from 'apps/client/app';
import { ProfileModel, ProfileApp } from 'apps/profile/app';

import { ConfirmProfileMutation } from 'apps/profile/gql';

export class GatewayManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('profile', ProfileApp);
    this.InitialCheckup();
    const disposeWhen = when(
      () => this.profile && this.profile.profileConfirmed,
      () => {
        client.cache.reset().then(() => {
          const url = sessionStorage.getItem('sharedFileURLCreatedWithHMAC');
          if (url) {
            window.location.href = url;
          } else {
            clientStore.routerStore.navigateNext();
          }
        });
      },
    );
    this.disposers.push(disposeWhen);
  }

  async InitialCheckup() {
    const encodedUsername = this.params.get('utoken');
    const { signedInProfile } = clientStore;
    this.signInManager = clientStore.context.get('signInAppManager');

    if (!(encodedUsername || signedInProfile)) {
      clientStore.routerStore.navigateNext();
      return;
    }

    const username = encodedUsername
      ? atob(encodedUsername)
      : signedInProfile.username;

    // FIXME - hack so client middleware finds a profile to build CLIENT-USERNAME header
    const userProfile = new ProfileModel();
    userProfile.username = username;
    clientStore.toLocalStorage('signedInProfile', userProfile);

    const profileModel = await clientStore.WhoAmI();

    if (!profileModel || this.profile) return;

    if (!profileModel.profileConfirmed) {
      this.SetUpForm(profileModel);
    } else {
      this.SetProfile(profileModel);
    }
  }

  @computed get loading() {
    return !(this.profile && this.profile.gatewayForm);
  }

  @action SetProfile = profileModel => {
    this.profile = profileModel;
  };

  @action SetUpForm = profileModel => {
    if (!profileModel) return;
    this.profile = profileModel;
    this.profile.createGatewayForm({ email: !profileModel.user.email });
    const inputParams = {
      username: () => this.profile.username.split('@')[1],
      fullName: () => this.profile.fullName,
      // bio: () => this.profile.bio,
      // intentId: () => this.profile.intent,
      // userTypeId: () => this.profile.userType,
    };
    if (!profileModel.user.email) {
      inputParams.email = () => this.profile.email;
    }
    this.confirmProfileInput = new Input(inputParams);
  };

  @action Submit = () => {
    if (!this.profile.gatewayForm.isValid) {
      this.profile.gatewayForm.alert();
      return null;
    }
    this.profile.gatewayForm.SetPosting(true);
    clientStore.SetPosting(true);
    const mutation = new ConfirmProfileMutation(
      this.confirmProfileInput,
      null,
      {
        onSuccess: this.OnSuccess,
        onSysErr: this.OnErr,
        onUserErr: this.OnErr,
      },
    );
    mutation.mutate();
    return mutation;
  };

  @action OnSuccess = result => {
    if (this.profile && this.profile.gatewayForm) {
      this.profile.gatewayForm.SetPosting(false);
      this.profile.gatewayForm.clearDraft();
    }
    const profileModel = ProfileModel.Load(result);
    this.profile = profileModel;
    this.signInManager.SetProfile(profileModel);
    clientStore.SetPosting(false);

    const { username } = result;
    analytics.sendEvent('complete-signup');
    analytics.sendEvent(
      'CompleteRegistration',
      { value: 1, currency: 'EUR' },
      { twitter: true, facebook: true },
    );
    analytics.linkedinPixel('1169145');
    Alert.success(i18next.t('Welcome, {{username}}!', { username }));
  };

  @action OnErr = error => {
    this.profile.gatewayForm.SetServerErrs(error);
    this.profile.gatewayForm.SetPosting(false);
    clientStore.SetPosting(false);
  };
}
